const routes = [
    {
        path: '/',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'formularioRelatoriosCurvaAbc',
                path: '/relatorios_curvas_abc/relatorio_produto',
                component: () => import('../views/Produto')
            },
            {
                name: 'formularioRelatoriosCurvaAbc',
                path: '/relatorios_curvas_abc/relatorio_cliente',
                component: () => import('../views/Cliente')
            }
        ]
    }
]

export default routes